<template>
  <div class="movie">
    <app-loader v-if="loading" />

    <div
      v-else
      class="movie__details"
    >
      <section
        class="movie__top"
        :style="{backgroundImage: getImgSrc}"
      >
        <v-container class="pt-2 pb-0 px-2 mb-0">
          <v-layout row>
            <v-breadcrumbs>
              <template v-slot:divider>
                <v-icon dark>
                  arrow_right
                </v-icon>
              </template>
              <v-breadcrumbs-item
                to="/"
                exact
                class="breadcrumbs"
              >
                Startseite
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                to="/filme"
                exact
                class="breadcrumbs"
              >
                Filme
              </v-breadcrumbs-item>
              <v-breadcrumbs-item disabled>
                {{ title }}
              </v-breadcrumbs-item>
            </v-breadcrumbs>
            <v-spacer />
            <v-btn
              small
              flat
              class="movie__back-btn white--text caption"
              @click="$router.go(-1)"
            >
              <v-icon
                left
                dark
                class="ma-0"
              >
                arrow_left
              </v-icon>Zurück
            </v-btn>
          </v-layout>
        </v-container>

        <v-container class="py-0">
          <div class="movie__top-wrapper">
            <div
              v-if="!isMobile"
              class="movie__picture"
            >
              <v-img
                class="movie__img elevation-7"
                :src="poster ? `${medImgPrefix}${poster}` : noPosterSrc"
                :lazy-src="gradient"
                :fade-transition="true"
              >
                <v-layout
                  slot="placeholder"
                  fill-height
                  align-center
                  justify-center
                  ma-0
                >
                  <v-progress-circular
                    indeterminate
                    :width="3"
                    color="red"
                  />
                </v-layout>
              </v-img>
            </div>

            <div class="movie__top-content">
              <h1 class="movie__title">
                {{ title }} ({{ date | getYear }})
              </h1>
              <div class="movie__genres">
                <v-btn
                  v-for="(genre, gId) in genres"
                  :key="gId"
                  small
                  flat
                  class="white--text"
                  @click="onGenreClick(genre)"
                >
                  {{ genre.name }}
                </v-btn>
              </div>

              <div class="movie__actions">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-progress-circular
                      :rotate="-90"
                      :size="40"
                      :value="rate * 10"
                      :color="getRateColor"
                      class="mx-2"
                      v-on="on"
                    >
                      <span class="caption">{{ rate * 10 }}%</span>
                    </v-progress-circular>
                  </template>
                  <span>Gefiel {{ rate * 10 }}% der Nutzer</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <v-btn
                    v-if="!isFavor"
                    slot="activator"
                    fab
                    small
                    class="mx-2"
                    :disabled="!checklogin"
                    color="blue-grey darken-1"
                    @click="addToFavor"
                  >
                    <v-icon>bookmark</v-icon>
                  </v-btn>

                  <v-btn
                    v-else
                    slot="activator"
                    fab
                    small
                    class="mx-2"
                    :disabled="!checklogin"
                    color="blue-grey darken-1"
                    @click="deleteFromFavor(getFavList.findIndex(el => el.id === id))"
                  >
                    <v-icon color="amber accent-4">
                      bookmark
                    </v-icon>
                  </v-btn>

                  <span v-if="checklogin && !isFavor">Zu meinen Favoriten hinzufügen</span>
                  <span v-else-if="checklogin && isFavor">Aussa mid dem Zeig aus meine Favoriten</span>
                  <span v-else>Meld di erst moi o!</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <app-trailer-modal
                    slot="activator"
                    :video-id="trailer ? trailer.key : ''"
                  />
                  <span v-if="trailer">{{ trailer.name }}</span>
                  <span v-else>Do gibts no nix</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <app-carousel
                    slot="activator"
                    :images="movieImages"
                  />
                  <span v-if="movieImages.length !== 0">Weitere Filmbilder</span>
                  <span v-else>Gibd no koa buidl</span>
                </v-tooltip>
              </div>

              <div class="movie__items">
                <p class="my-1">
                  {{ date| parseDate }} - {{ runtime | getHours }}
                </p>
                <h3 class="movie__items-title">
                  Handlung:
                </h3>
                <p class="movie__items-overview">
                  {{ overview }}
                </p>
                <!-- <h3 class="movie__items-title">
                  Haupt-Crew:
                </h3>
                <ul>
                  <li class="movie__item">
                    <span>Regisseur:</span>
                    {{ director }}
                  </li>
                </ul> -->
              </div>
            </div>
          </div>
        </v-container>
      </section>

      <section class="movie__bottom">
        <v-container>
          <!-- <div class="movie__actors-container">
            <h3 class="movie__actors-title">
              Darsteller:
            </h3>

            <div class="movie__actors-wrapper">
              <div
                v-if="cast.length !== 0"
                class="movie__actors"
              >
                <div class="movie__actors-inner">
                  <div
                    v-for="actor in cast"
                    :key="actor.id"
                    class="movie__actor-card"
                  >
                    <router-link
                      class="movie__actor-link"
                      :to="'/person/' + actor.id"
                    >
                      <v-lazy-image
                        :src="actor.profile_path ? `${actorPrefix}${actor.profile_path}` : noAvatarSrc"
                        :src-placeholder="gradient"
                        class="movie__actor-img"
                      />

                      <div class="movie__actor-text">
                        <p class="movie__actor-cred">
                          {{ actor.name }}
                        </p>
                        <p
                          class="movie__actor-name"
                        >
                          {{ actor.character ? actor.character : `------` }}
                        </p>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>

              <div v-else>
                <p
                  class="movie__no-actors"
                >
                  Wias ausschaut fein do de Infos für de Schauspieler vo dem Film
                </p>
              </div>
            </div>
          </div> -->
          <app-person-overview
            v-if="cast.length > 0"
            :credits="cast"
          />
        </v-container>
      </section>

      <section
        v-if="similiar.movies.length !== 0"
        class="movie__similiar"
      >
        <v-container class="pb-0">
          <h3 class="movie__similiar-title">
            Des kannd a no wos für di sei:
          </h3>
        </v-container>

        <app-card :items="similiar" />
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import _ from 'lodash';
import { base } from '../config/config';

import TrailerModal from '../components/TrailerModal.vue';
import Carousel from '../components/Carousel.vue';
import MovieCard from '../components/MovieCard.vue';
import PersonOverview from '../components/PersonOverview.vue';

const noBannerSrc = require('../assets/no-banner.jpg');
const noPosterSrc = require('../assets/noposter.jpg');
const noAvatarSrc = require('../assets/avatar.jpg');
const gradient = require('../assets/gradient.jpg');

export default {
  name: 'Movie',
  components: {
    appTrailerModal: TrailerModal,
    appCarousel: Carousel,
    appCard: MovieCard,
    appPersonOverview: PersonOverview,
  },
  filters: {
    getYear(val) {
      return val
        .split('-')
        .slice(0, 1)
        .join('');
    },
    parseDate(val) {
      return val
        .split('-')
        .reverse()
        .join('.');
    },
    getHours(val) {
      if (val) {
        const num = val;
        const hours = (num / 60);
        const rHours = Math.floor(hours);
        const minutes = (hours - rHours) * 60;
        const rMinutes = Math.round(minutes);
        return `${rHours} Std. ${rMinutes} Min.`;
      }
      return '';
    },
  },
  data() {
    return {
      id: parseInt(this.$route.params.id, 10),
      imgPrefix: base.imgPrefix,
      medImgPrefix: base.medImgPrefix,
      posterPrefix: base.posterPrefix,
      actorPrefix: base.medProfilePrefix,
      noBannerSrc,
      noPosterSrc,
      noAvatarSrc,
      gradient,
      isMobile: false,
      title: '',
      country: '',
      date: '',
      rate: '',
      votePercent: 0,
      overview: '',
      genres: [],
      genresString: '',
      runtime: '',
      poster: '',
      backdrop: '',
      cast: [],
      crew: [],
      directors: [],
      groupedCrew: {},
      crewByName: {},
      videos: [],
      trailer: {},
      movieImages: [],
      similiar: { movies: [] },
      belongsToCollection: {}, // TODO: Movie Collection Detail?
    };
  },
  computed: {
    ...mapState({
      getFavList(state) {
        return state.favors.favors.movies;
      },
    }),
    isFavor() {
      return this.getFavList.findIndex(el => el.id === this.id) !== -1;
    },
    loading() {
      return this.$store.getters.loading;
    },
    checklogin() {
      return this.$store.getters.login;
    },
    gaugeActorsLength() {
      return this.cast.length > 5 ? 'shorten' : '';
    },
    getImgSrc() {
      return this.backdrop
        ? `linear-gradient(to bottom right, rgba(77, 77, 77, 0.7), rgba(77, 77, 77, 0.3)), url("${
          this.posterPrefix
        }${this.backdrop}")`
        : `linear-gradient(to bottom right, rgba(77, 77, 77, 0.7), rgba(77, 77, 77, 0.3)), url("${
          this.noBannerSrc
        }")`;
    },
    getRateColor() {
      let color;

      if (this.rate === 0 || this.rate === '') color = '#bdbdbd';
      if (this.rate >= 1 && this.rate < 5) color = 'error';
      if (this.rate >= 5 && this.rate < 7) color = 'warning';
      if (this.rate >= 7) color = 'success';

      return color;
    },
    paintRate() {
      let color;

      if (this.rate === 0 || this.rate === '') color = 'movie__rating--no';
      if (this.rate >= 1 && this.rate < 5) color = 'movie__rating--low';
      if (this.rate >= 5 && this.rate < 7) color = 'movie__rating--mid';
      if (this.rate >= 7) color = 'movie__rating--high';

      return color;
    },
  },
  created() {
    console.log('created called...');

    this.initMoviePage();
    this.checkScreenWidth();
  },
  mounted() {
    console.log('mounted called..');
  },
  methods: {
    checkScreenWidth() {
      if (window.innerWidth <= 768) {
        this.isMobile = true;
      }
    },
    addToFavor() {
      const movie = {
        type: 'movie',
        id: this.id,
        poster_path: this.poster,
        title: this.title,
        release_date: this.date,
        vote_average: this.rate,
      };

      this.$store.dispatch('addToFavorList', movie);
    },
    deleteFromFavor(index) {
      const id = this.getFavList[index].fbId;
      this.$store.dispatch('deleteFromFavorList', { id, title: this.title });
    },
    async getDetails() {
      try {
        const res = await axios.get(
          `${base.urlPrefix}/movie/${this.id}?api_key=${base.key}&${
            base.language
          }`,
        );
        const { data } = res;
        this.title = data.title;
        this.country = data.production_countries;
        this.date = data.release_date;
        this.rate = data.vote_average;
        this.overview = data.overview;
        this.genres = data.genres;
        this.runtime = data.runtime;
        this.poster = data.poster_path;
        this.backdrop = data.backdrop_path;
      } catch (error) {
        this.$store.commit(
          'setError',
          `Uups! Do is wos schief glaffa: ${error.message}`,
        );
      }
    },
    async getFallbackDetails() {
      try {
        const res = await axios.get(
          `${base.urlPrefix}/movie/${this.id}?api_key=${
            base.key
          }&language=en-US`,
        );
        const { data } = res;
        if (data.overview) {
          this.overview = data.overview;
        } else {
          this.overview = 'Nicht verfügbar im Moment...';
        }
      } catch (error) {
        this.$store.commit(
          'setError',
          `Uups! Do is wos schief glaffa: ${error.message}`,
        );
      }
    },
    async getCredits() {
      try {
        const res = await axios.get(
          `${base.urlPrefix}/movie/${this.id}/credits?api_key=${base.key}`,
        );
        const { data } = res;
        // console.log(data);

        if (data.cast.length > 0) {
          // TODO: sort cast per 'order'
          this.cast = _.orderBy(data.cast, 'order', 'asc');
        }
        if (data.crew.length > 0) {
          this.crew = data.crew;
        }
      } catch (error) {
        this.$store.commit(
          'setError',
          `Uups! Do is wos schief glaffa: ${error.message}`,
        );
      }
    },
    async getVideos() {
      try {
        let res = await axios.get(
          `${base.urlPrefix}/movie/${this.id}/videos?api_key=${base.key}&${
            base.language
          }`,
        );
        if (res.data.results.length > 0) {
          const { data } = res;
          this.videos = data.results;
        } else {
          res = await axios.get(
            `${base.urlPrefix}/movie/${this.id}/videos?api_key=${base.key}`,
          );
          const { data } = res;
          this.videos = data.results;
        }
      } catch (error) {
        // this.$store.commit(
        //   'setError',
        //   `Uups! Do is wos schief glaffa in "getVideos():" ${error.message}`,
        // );
      }
    },
    async getImages() {
      try {
        const res = await axios.get(
          `${base.urlPrefix}/movie/${this.id}/images?api_key=${base.key}`,
        );
        const { data } = res;
        this.movieImages = data.backdrops;
      } catch (error) {
        this.$store.commit(
          'setError',
          `Uups! Do is wos schief glaffa: ${error.message}`,
        );
      }
    },
    async getSimiliar() {
      try {
        const res = await axios.get(
          `${base.urlPrefix}/movie/${this.id}/similar?api_key=${base.key}&${
            base.language
          }&page=1`,
        );
        const { data } = res;
        this.similiar.movies = data.results;
      } catch (error) {
        this.$store.commit(
          'setError',
          `Uups! Do is wos schief glaffa: ${error.message}`,
        );
      }
    },
    parceCountry() {
      if (this.country.length > 0) {
        const countries = this.country.map(el => el.name);

        this.country = countries.join(', ');
      } else {
        this.country = '';
      }
    },
    parceDirector() {
      // TODO: Regisseur/Produzenten aus crew liste filtern
      let director;
      // console.log('parceDirector():', this.credits.crew[0]);

      if (this.crew.length !== 0) {
        director = this.crew[0].name;
        // console.log("director: ", director);

        this.crew = director;
      }
    },
    parceGenere() {
      if (this.genres.length > 0) {
        const genres = this.genres.map(el => el.name);

        this.genresString = genres.join(', ');
      } else {
        this.genresString = '';
      }
    },
    groupCrew(credits, groupBy = 'department') {
      const sorted = _
        .chain(credits)
        .groupBy(groupBy)
        .map((value, key) => ({
          department: key,
          crew: value,
        }))
        .value();
      return sorted;
    },
    getDirectors() {
      let directors = [];
      if (this.groupedCrew) {
        this.groupedCrew.forEach((element) => {
          if (element.department === 'Directing') {
            // console.log('directors:', element.crew);
            if (element.crew.length > 0) {
              directors = element.crew;
            }
          }
        });
      }
      return directors;
    },

    parceTrailer() {
      if (this.videos.length !== 0) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.videos.length; i++) {
          const video = this.videos[i];
          if (video.type === 'Trailer') {
            this.trailer = video;
            break;
          }
        }
      } else {
        this.trailer = '';
      }
    },
    async initMoviePage() {
      this.$store.commit('clearError');
      this.$store.commit('setLoading', true);

      await this.getDetails();
      if (!this.overview) {
        await this.getFallbackDetails();
      }
      await this.getCredits();
      await this.getVideos();
      await this.getImages();
      await this.getSimiliar();

      this.parceCountry();
      // this.parceDirector();
      this.groupedCrew = this.groupCrew(this.crew);
      // console.log('groupedCrew:', this.groupedCrew);

      this.crewByName = this.groupCrew(this.crew, 'name');
      // console.log('crewByName:', this.crewByName);

      this.directors = this.getDirectors();

      this.parceGenere();
      this.parceTrailer();

      this.$store.commit('setLoading', false);
    },
    async setVotes(timeout) {
      await setTimeout(() => {
        this.votePercent = this.rate * 10;
      }, timeout);
    },
    onGenreClick(genre) {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const nowString = `${year}-${month}-${day}`;

      const customParams = {
        genere: genre.id,
        rate: '',
        country: '',
        sort: 'popularity.desc',
        yearFrom: '',
        yearTill: '',
        actor: '',
      };
      this.$store.commit('resetParamsResults');
      // TODO: ParamSearch.vue für Serien anpassen!
      // Filter... etc
      // evtl. über Route anstatt paramSearch?!
      // route /genre/:id/filme bzw /genre/:id/serien
      this.$router.push('/erweiterte-suche');
      this.$store.dispatch('getParamResults', { params: customParams });
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.id = parseInt(to.params.id, 10);
    this.initMoviePage();
    this.checkScreenWidth();
    next();
  },
};
</script>

<style lang="scss" scoped>
.v-lazy-image {
  display: block;
  width: 100%;
  // height: 75%;
  filter: blur(10px);
  transition: filter 0.5s;
}

.v-lazy-image-loaded {
  filter: blur(0);
}

.movie {
  position: relative;
  height: 100%;

  &__top {
    position: relative;
    background-size: cover;
    background-position: center top;
    // height: 500px;

    @media (max-width: 1263px) {
      // height: 400px;
    }

    @media (max-width: 768px) {
      // height: 340px;
    }

    @media (max-width: 600px) {
      // height: 300px;
    }
  }

  &__top-wrapper {
    position: relative;
    display: flex;
  }

  &__picture {
    position: relative;
    min-width: 300px;
    max-height: 450px;
    overflow: hidden;
    box-shadow: 0 0 20px rgba(0,0,0,0.4);
    animation-delay: 0.5s;

    @media (max-width: 1263px) {
      min-width: 235px;
      max-height: 352px;
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  &__img {
    display: block;
    width: 100%;
  }

  &__top-content {
    width: 100%;
    min-height: 450px;
    animation-delay: 0.5s;
  }

  &__title {
    margin-left: 30px;
    font-size: 1.6rem;
    line-height: 20px;
    font-weight: 450;

    @media (max-width: 768px) {
      // font-weight: 500;
      font-size: 18px;
      margin-left: 0;
    }

    @media (max-width: 600px) {
      line-height: 18px;
      margin-bottom: 10px;
    }
  }

  &__year {
    font-size: 20px;

    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  &__genres {
    padding: 5px 15px 0px;

    @media (max-width: 768px) {
      padding: 5px 0 0;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    padding-left: 30px;
    margin-top: 5px;
    border-top: 1px solid #546e7a;
    background-color: rgba(0, 0, 0, 0.6);

    @media (max-width: 768px) {
      margin-top: 10px;
      padding: 0 20px;
    }

    @media (max-width: 425px) {
      display: flex;
      justify-content: space-between;
    }
  }

  &__rating {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    min-height: 40px;
    text-align: center;
    border-radius: 50%;
    margin-right: 10px;
    cursor: default;
    box-shadow: 0 3px 10px 2px rgba(0, 0, 0, 0.1);
    color: #fff;

    &--no {
      background-color: #bdbdbd;
    }

    &--low {
      background-color: #d84315;
    }

    &--mid {
      background-color: #ffa726;
    }

    &--high {
      background-color: #43a047;
    }

    @media (max-width: 600px) {
      margin-left: 10px;
    }
  }

  &__items {
    padding: 10px 30px;
    margin-top: 10px;
    list-style: none;
    font-size: 1em;
    font-weight: 380;
    text-align: justify;
    border-top: 1px solid #546e7a;
    background-color: rgba(0, 0, 0, 0.6);

    @media (max-width: 960px) {
      font-size: 14px;
    }

    @media (max-width: 768px) {
      padding: 10px 20px;
      font-size: 14px;
    }

    @media (max-width: 600px) {
      margin-top: 15px;
      font-size: 13px;
    }

    span {
      font-weight: 400;
    }
  }

  &__items-title {
    font-weight: 400;
    font-size: 20px;
    margin-bottom: 10px;
    border-bottom: 1px solid #546e7a;
  }

  &__items-overview {
    // margin-bottom: 0;
  }

  &__item {
    font-weight: 300;
    margin-bottom: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    @media (max-width: 960px) {
      margin-bottom: 5px;
    }

    @media (max-width: 600px) {
      padding-left: 10px;
      margin-bottom: 4px;
    }
  }

  &__director-link {
    text-decoration: none;
    color: #fff;
      &:hover {
        background-color: rgba(255,255,255,0.2);
      }
  }

  &__bottom {
    animation-delay: 0.5s;
  }

  &__bottom-content {
    display: flex;

    @media (max-width: 1263px) {
      flex-direction: column;
    }
  }

  &__bottom-left {
    width: 55%;
    padding-right: 20px;

    @media (max-width: 1263px) {
      width: 100%;
      margin-bottom: 30px;
      padding: 0;
    }

    @media (max-width: 600px) {
      margin-bottom: 10px;
    }
  }

  &__bottom-right {
    width: 45%;

    @media (max-width: 1263px) {
      width: 100%;
    }
  }

  &__images {
    display: flex;
    align-items: flex-end;
  }

  &__overview-title,
  &__actors-title,
  &__similiar-title {
    width: 100%;
    font-weight: 300;
    margin-bottom: 15px;
    font-size: 20px;
    border-bottom: 1px solid #546e7a;

    @media (max-width: 768px) {
      font-size: 18px;
    }

    @media (max-width: 600px) {
      margin-bottom: 10px;
    }
  }

  &__overview-text,
  &__no-actors {
    font-size: 14px;
    font-weight: 300;
    text-align: justify;

    @media (max-width: 600px) {
      font-size: 13px;
    }
  }

  &__actors-wrapper {
    overflow-x: auto;
    // height: 320px;
    padding-bottom: 10px;
    @media (max-width: 600px) {
      overflow-x: scroll;
    }
  }

  &__actors-inner {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;

    @media (max-width: 600px) {
      width: 570px;
    }
  }

  &__actors-inner.shorten {
    .movie__actor-card {
      margin-right: 0;

      &:last-child {
        margin-right: 0;
      }

      &:nth-last-child(-n + 2) {
        @media (max-width: 2000px) {
          display: none;
        }

        @media (max-width: 1263px) {
          display: block;
        }
      }
    }
  }

  &__actor-card {
    min-width: 13.3%;
    max-width: 13.3%;
    // max-width: 120px;
    // max-height: 250px;
    margin-right: 13px;
    transition: transform 0.25s ease-in-out;

    &:hover {
      @media (min-width: 959px) {
        transform: translateY(-5px);
      }
    }

    &:last-child {
      margin-right: auto;
    }

    @media (max-width: 768px) {
      min-width: 18.3%;
      max-width: 18.3%;
    }

    @media (min-width: 769px) {
      min-width: 15.4%;
      max-width: 15.4%;
    }

    @media (min-width: 1264px) {
      min-width: 13.3%;
      max-width: 13.3%;
    }
  }

  &__actor-link {
    text-decoration: none;
  }

  &__actor-picture {
    display: block;
  }

  &__actor-img {
    height: 80%;
  }

  &__actor-text {
    color: #f1f1f1;
    padding: 5px 0;
    text-align: center;
    font-size: 12px;
    font-weight: 300;
    background-color: rgba(0, 0, 0, 0.1);
  }

  &__actor-cred,
  &__actor-name {
    margin: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &__actor-cred {
    font-weight: 400;
  }
}
</style>
